<template>
  <div class="newMarkerWrapper">
    <div class="newMarker">
      <div class="alignRight">
        <button title="Abbrechen" @click="abort()" class="btn--subtile btn--icon"><svgicon icon="close" width="32" height="32" color="#000000"></svgicon></button>
      </div>

      <div v-if="type == 'post'">
        <h1>Neuer Beitrag</h1>
        <label>
          Titel
          <input v-model="title" id="titelinput" @keyup.enter="set()">
        </label>
        <br />
        <button @click="set()" v-bind:class="{ locked: !ready }">Jetzt platzieren &raquo;</button>
      </div>

      <div v-if="type == 'link'">
        <h1>Neue Verknüpfung</h1>
        <label>
          Titel
          <input v-model="title" @keyup.enter="set()">
        </label>
        <br />
        <label>
          Link
          <input type="url" v-model="link" @keyup.enter="set()">
        </label>
        <br />
        <!-- <label>
          Icon<br />
        </label>
        <button v-for="ic in icons" v-bind:class="iconClass(ic.name, icon)" @click="selectIcon(ic.name)" v-bind:key="ic['.key']" class="btn--icon">
          <svgicon :icon="ic.name" width="24" height="24" color="#000000"></svgicon>
        </button>
        <br /> -->
        <button @click="set()" v-bind:class="{ locked: !ready }">Jetzt platzieren &raquo;</button>
      </div>

      <div v-if="type == 'area'">
        <h1>Neuer Bereich</h1>
        <label>
          Titel
          <input v-model="title" @keyup.enter="set()">
        </label>
        <br />
        <button @click="set()" v-bind:class="{ locked: !ready }">Jetzt platzieren &raquo;</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'mapCreateNew',
  props: ['type', 'icons'],
  data () {
    return {
      title: null,
      link: null,
      icon: 'note',
      priority: '3'
    }
  },
  mounted () {
    document.getElementById('titelinput').focus()
  },
  methods: {
    abort: function () {
      this.$emit('abortCreateNew')
    },
    set: function () {
      if (!this.ready) return
      let data = {
        title: this.title,
        link: this.link,
        icon: this.icon,
        type: this.type,
        priority: this.priority
      }
      this.$emit('setNew', data)
      // default werte wenn möglich setzen und prüfen ob alle nötigen werte für den typ vorhanden sind
    },
    iconClass: function (current, active) {
      if (current === active) {
        return 'btn--icon btn--selected'
      } else {
        return 'btn--icon btn--subtile'
      }
    },
    selectIcon: function (icon) {
      this.icon = icon
    }
  },
  computed: {
    // a computed getter
    ready: function () {
      if (this.type === 'post') {
        if ((this.title != null && this.title.length > 3) && this.icon != null) {
          return true
        }
      }
      if (this.type === 'link') {
        if ((this.title != null && this.title.length > 3) && this.icon != null && this.link != null) {
          return true
        }
      }
      if (this.type === 'area') {
        if ((this.title != null && this.title.length > 3)) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  .newMarkerWrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 10;
    background: rgba($color-highlight, 0.5);
    display: grid;
    height: 100vh;
    margin: 0;
    place-items: center center;
  }
  .newMarker {
    background: #fff;
    box-shadow: 0 2px 24px 0 rgba(38,50,56,0.1);
    box-sizing: border-box;
    padding: 30px;
    width: 60%;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;;
    // margin-top: 10vh;
    max-height: 80vh;
    overflow: scroll;
    h1 {
      margin-top: 0;
    }
    button {
      margin-bottom: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/MapCreateNew.vue